import { typePageOptions, getCurrentPeriod } from '@/utils';
import { text, swapHorizontal, printer, close, edit, download, list, calendar, numeric } from '@/utils/icons';
import { required } from '@/utils/rules';
import MdfeBusiness from '@/business/MdfeBusiness';

export default {
  domain: 'mdfes',
  domainSingle: 'mdfe',
  title: 'MDF-e',
  description: 'Lista de todos os MDF-e do sistema',
  business: MdfeBusiness,
  createBtn: 'Nova MDF-e',
  showInactive: false,
  showExpand: true,
  routes: {
    list: {
      name: 'mdfes',
      path: '/mdfes',
      meta: { typePage: typePageOptions.list, requiresAuth: true },
    },
    create: {
      name: 'mdfe-create',
      path: '/mdfes/novo',
      meta: { typePage: typePageOptions.create, requiresAuth: true },
    },
    show: {
      name: 'mdfe-show',
      path: '/mdfes/:id',
      meta: { typePage: typePageOptions.show, requiresAuth: true },
    }
  },
  listActions: {
    has: true,
    noShow: false,
    noDestroy: false,
    more: {
      has: true,
      items: [
        {
          label: 'Transmitir para Sefaz',
          icon: swapHorizontal,
          iconColor: 'success',
          name: 'openConfirmationModal',
          action: 'openConfirmationModal',
          component: null
        },
        // {
        //   label: 'Imprimir DAMDFE',
        //   icon: printer,
        //   iconColor: 'secondary',
        //   name: 'printDamdfe',
        //   action: 'printDamdfe',
        //   component: null
        // },
        // {
        //   label: 'Download DAMD-e',
        //   icon: download,
        //   iconColor: 'secondary',
        //   name: 'downloadDamdfe',
        //   action: 'downloadDamdfe',
        //   component: null
        // },
        // {
        //   label: 'Alterar Número MDF-e',
        //   icon: numeric,
        //   iconColor: 'secondary',
        //   name: 'changeNumberMdfe',
        //   action: 'changeNumberMdfe',
        //   component: 'ChangeNumberNFe'
        // },
        // {
        //   label: 'Cancelar MDF-e',
        //   icon: close,
        //   iconColor: 'red',
        //   name: 'cancelMdfe',
        //   action: 'cancelMdfe',
        //   component: 'CancelMdfe'
        // },
        // {
        //   label: 'Eventos',
        //   icon: list,
        //   iconColor: 'secondary',
        //   name: 'events',
        //   action: 'events',
        //   component: 'ListEvents'
        // },
        // {
        //   label: 'Download XML',
        //   icon: download,
        //   iconColor: 'secondary',
        //   name: 'downloadXmlMdfe',
        //   action: 'downloadXmlMdfe',
        //   component: null
        // }
      ]
    },
  },
  filters: {
    has: false,
    isBetween: true,
    columnBetween: 'created_at',
    items: []
  },
  fields: [
    {
      title: 'Dados do MDF-e',
      icon: text,
      openGroup: true,
      readonly: true,
      items: [
        {
          type: 'text',
          name: 'created_at',
          formattedName: 'created_at_formatted',
          label: 'Data',
          align: '',
          md: '2',
          rules: [required],
          list: true,
          readonly: false,
          disabled: false,
        },
        {
          type: 'text',
          name: 'product_invoice.client.name',
          formattedName: 'product_invoice.client.name',
          label: 'Cliente',
          align: '',
          md: '2',
          rules: [required],
          list: true,
          readonly: false,
          disabled: false,
        },
        {
          type: 'text',
          name: 'product_invoice.nf_number',
          formattedName: 'product_invoice.nf_number',
          label: 'N° NF-e',
          align: '',
          md: '2',
          rules: [required],
          list: true,
          readonly: false,
          disabled: false,
        },
        {
          type: 'text',
          name: 'product_invoice.key_nfe',
          formattedName: 'product_invoice.key_nfe',
          label: 'Chave da NF-e',
          align: '',
          md: '3',
          rules: [required],
          list: true,
          readonly: false,
          disabled: false,
        },
        {
          type: 'text',
          name: 'status',
          formattedName: 'status_formatted',
          label: 'Status',
          align: '',
          md: '4',
          rules: [required],
          list: true,
          readonly: false,
          disabled: false,
        },
        {
          type: 'text',
          name: 'identification.environment',
          formattedName: 'identification.environment_formatted',
          label: 'Ambiente',
          align: '',
          md: '4',
          rules: [required],
          list: false,
          readonly: false,
          disabled: false,
          contentExpanded: true,
        },
      ],
    },
  ],
  footer: [],
};
